<template>
  <transition name="modal">
    <div v-if="errorData" class="layer-modal">
      <div class="toast">
        <div class="modal-container">
          <p v-if="isHtmlMessage" v-html="errorData.message"></p>
          <p v-else>{{ errorData.message }}</p>

          <p class="btns">
            <button type="button" class="btn_2"
              @click="onDialogResove(errorData.action)">
              {{ $t('common.confirm') }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import modalEvent from '@/lib/modal-event'

export default {
  name: 'ErrorDialog',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['errorData']),
    isHtmlMessage () {
      if (this.errorData.message) {
        return this.errorData.message.indexOf('<br>') !== -1
      }
      return false
    }
  },
  methods: {
    onDialogResove (value) {
      modalEvent.resolveError(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/ErrorDialog.vue